module.exports = __webpack_public_path__ + "static/media/LOADER_03.3141d876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_03.png
// module id = 311
// module chunks = 0